import { formatDate } from '@angular/common';

/**
 * The one way a date is turned into text for a user in this application.
 *
 * Kept as a plain function rather than a pipe or an injectable so that services can use it too —
 * the deactivated sign-in message is built in Authorization, and a second formatter there would put
 * the same date on screen in two shapes depending on which part of the app rendered it.
 */
export const DAY_MONTH_YEAR = 'dd/MM/yyyy';

/**
 * The backend sends these as epoch milliseconds, which arrive as a numeric string — parsed as a
 * number, because Date() reads a numeric string as a year. Returns "" for anything unusable, so a
 * missing date renders as nothing rather than as "Invalid Date".
 */
export function formatDayMonthYear(value: any): string {
  if (value === null || value === undefined || value === "") { return ""; }

  const parsed = (typeof value === "number" || !isNaN(Number(value)))
    ? new Date(Number(value))
    : new Date(value);
  if (isNaN(parsed.getTime())) { return ""; }

  return formatDate(parsed, DAY_MONTH_YEAR, 'en-US');
}
